var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "senior-setup" },
    [
      _vm.currentMenu == 1
        ? _c("div", { staticClass: "setup-main-1" }, [
            _c("div", { staticClass: "item-setup" }, [
              _c(
                "div",
                { staticClass: "setup-top-con" },
                [
                  _vm._m(0),
                  _c("el-switch", {
                    attrs: {
                      "inactive-color": "#E4F7F4",
                      "active-color": "#00B498",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updateProAutoDedup("enable", $event)
                      },
                    },
                    model: {
                      value: _vm.autoDeduplicationSettings.enable,
                      callback: function ($$v) {
                        _vm.$set(_vm.autoDeduplicationSettings, "enable", $$v)
                      },
                      expression: "autoDeduplicationSettings.enable",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "setup-title-con" }, [
                _c("div", { staticClass: "name" }, [_vm._v("自动去重")]),
                _c(
                  "div",
                  { staticClass: "more", on: { click: _vm.onFixRepeat } },
                  [_vm._v("更多")]
                ),
              ]),
              _c("div", { staticClass: "setup-info" }, [
                _vm._v(
                  "审批流程中审批人重复出现时，只需审批一次其余自动通过。"
                ),
              ]),
            ]),
            _c("div", { staticClass: "item-setup" }, [
              _c(
                "div",
                { staticClass: "setup-top-con" },
                [
                  _vm._m(1),
                  _c("el-switch", {
                    attrs: {
                      "inactive-color": "#E4F7F4",
                      "active-color": "#00B498",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updateSign("allowAddApprovers", $event)
                      },
                    },
                    model: {
                      value: _vm.settings.allowAddApprovers,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "allowAddApprovers", $$v)
                      },
                      expression: "settings.allowAddApprovers",
                    },
                  }),
                ],
                1
              ),
              _vm._m(2),
              _c("div", { staticClass: "setup-info" }, [
                _vm._v("开启后审批流程可以新增临时审批人。"),
              ]),
            ]),
            _c("div", { staticClass: "item-setup" }, [
              _c(
                "div",
                { staticClass: "setup-top-con" },
                [
                  _vm._m(3),
                  _c("el-switch", {
                    attrs: {
                      "inactive-color": "#E4F7F4",
                      "active-color": "#00B498",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updateSign("allowRevocation", $event)
                      },
                    },
                    model: {
                      value: _vm.settings.allowRevocation,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "allowRevocation", $$v)
                      },
                      expression: "settings.allowRevocation",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "setup-title-con" }, [
                _vm.isProcess
                  ? _c("div", { staticClass: "name" }, [_vm._v("撤销")])
                  : _c("div", { staticClass: "name" }, [_vm._v("撤销/修改")]),
              ]),
              _c("div", { staticClass: "setup-info" }, [
                _vm._v("开启后发起人可以撤销审批中的审批。"),
              ]),
            ]),
            _c("div", { staticClass: "item-setup" }, [
              _c(
                "div",
                { staticClass: "setup-top-con" },
                [
                  _vm._m(4),
                  _c("el-switch", {
                    attrs: {
                      "inactive-color": "#E4F7F4",
                      "active-color": "#00B498",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.updateProTimeLimited("enable", $event)
                      },
                    },
                    model: {
                      value: _vm.timeLimitedApproval.enable,
                      callback: function ($$v) {
                        _vm.$set(_vm.timeLimitedApproval, "enable", $$v)
                      },
                      expression: "timeLimitedApproval.enable",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "setup-title-con" }, [
                _c("div", { staticClass: "name" }, [_vm._v("限时审批")]),
                _c(
                  "div",
                  { staticClass: "more", on: { click: _vm.onTimeLimited } },
                  [_vm._v("更多")]
                ),
              ]),
              _c("div", { staticClass: "setup-info" }, [
                _vm._v("设置审批时间限制，自动审批。"),
              ]),
            ]),
            _vm.isProcess
              ? _c("div", { staticClass: "item-setup" }, [
                  _c(
                    "div",
                    { staticClass: "setup-top-con" },
                    [
                      _vm._m(5),
                      _c("el-switch", {
                        attrs: {
                          "inactive-color": "#E4F7F4",
                          "active-color": "#00B498",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.updateSign("mustApproveRemark", $event)
                          },
                        },
                        model: {
                          value: _vm.settings.mustApproveRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "mustApproveRemark", $$v)
                          },
                          expression: "settings.mustApproveRemark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._m(6),
                  _c("div", { staticClass: "setup-info" }, [
                    _vm._v("审批流程中审批人/办理人审批时，必须填写备注。"),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.currentMenu == 2
        ? _c(
            "div",
            { staticClass: "setup-main-2" },
            [
              _vm._l(_vm.permissionsList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "item-permissions" },
                  [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v("权限组"),
                        index != 0
                          ? _c("span", [_vm._v(_vm._s(index))])
                          : _vm._e(),
                      ]),
                      index != 0
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-del",
                              on: {
                                click: function ($event) {
                                  return _vm.delPermissions(index)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "icon-close" }),
                              _vm._v("删除"),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      { staticClass: "row-con" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("权限成员"),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "select-u",
                            attrs: {
                              "value-key": "name",
                              size: "small",
                              clearable: "",
                              multiple: "",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.selectUser("admin")
                              },
                            },
                            model: {
                              value: item.person,
                              callback: function ($$v) {
                                _vm.$set(item, "person", $$v)
                              },
                              expression: "item.person",
                            },
                          },
                          _vm._l(item.admin, function (wc, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: wc.name, value: wc },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "row-con" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("管理范围"),
                        ]),
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "check-group",
                            model: {
                              value: item.manageScope,
                              callback: function ($$v) {
                                _vm.$set(item, "manageScope", $$v)
                              },
                              expression: "item.manageScope",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("自己负责的"),
                              ]),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("全公司"),
                              ]),
                            ]),
                            _c("el-radio", { attrs: { label: 3 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("下属的"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "row-con" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("操作权限"),
                        ]),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "check-group",
                            model: {
                              value: item.operateScope,
                              callback: function ($$v) {
                                _vm.$set(item, "operateScope", $$v)
                              },
                              expression: "item.operateScope",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: 1 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("打印"),
                              ]),
                            ]),
                            _c("el-checkbox", { attrs: { label: 2 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("查看"),
                              ]),
                            ]),
                            _c("el-checkbox", { attrs: { label: 3 } }, [
                              _c("span", { staticClass: "name-text" }, [
                                _vm._v("导出"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _c(
                "el-button",
                {
                  staticClass: "btn-new",
                  attrs: { type: "primary", icon: "el-icon-plus", plain: "" },
                  on: { click: _vm.addPermissions },
                },
                [_vm._v("新增权限组")]
              ),
              _c(
                "div",
                { staticClass: "form-other-set" },
                [
                  _c("div", { staticClass: "lable-title" }, [
                    _vm._v("权限组外人员查看权限"),
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "check-group",
                      model: {
                        value: _vm.otherScope,
                        callback: function ($$v) {
                          _vm.otherScope = $$v
                        },
                        expression: "otherScope",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _c("span", { staticClass: "name-text" }, [
                          _vm._v(
                            "权限组外人员即公司组织内的所有人员均可查看审批详情"
                          ),
                        ]),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _c("span", { staticClass: "name-text" }, [
                          _vm._v(
                            "权限组内人员以及表单流程内相关人员可查看审批详情"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _c("auto-fix-repeat", { ref: "AutoFixRepeat" }),
      _c("time-limited", { ref: "TimeLimited" }),
      _c("message-setting", { ref: "MessageSetting" }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "请选择权限成员", multiple: "", selected: _vm.select },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/formDesign/icon-quchong.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/formDesign/icon-addshenpiren.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "setup-title-con" }, [
      _c("div", { staticClass: "name" }, [_vm._v("允许添加审批人")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/formDesign/icon-chexiao.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/formDesign/icon-xianshi.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/formDesign/icon-beizhu.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "setup-title-con" }, [
      _c("div", { staticClass: "name" }, [_vm._v("审批备注必填")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }